import React from 'react'
import { withTranslation } from 'react-i18next';
import connect from 'react-redux/lib/connect/connect';
import { bindActionCreators } from 'redux';
import { CustomSelect } from '../common/formFields/customSelect';
import PropTypes from 'prop-types';

import { hasPermission } from '../../store/apiWrapper';
import { appContextActions } from '../../store/appContextStore';
import FieldHorizontal from '../common/formFields/fieldHorizontal';

class ReportPermissionsFormComponent extends React.Component {

    render() {
        if (hasPermission(null, "UserRatingMSP") || hasPermission(null, "UserCCB")) {
            return (
                <>
                    {hasPermission(null, "UserRatingMSP") && <hr />}
                    <FieldHorizontal label={this.props.t(`IRating.Report.Search.AllowedRating`)}>
                        <CustomSelect
                            value={this.props.publishAboveRatingValue}
                            onChange={val => {
                                const cleanedValue = val ? (Array.isArray(val) ? val : [val]) : [];
                                this.props.publishAboveRatingOnChange(cleanedValue);
                            }}
                            options={this.props.ratingRange.ratingRange.map(x => { return { value: x, label: x } })}
                            isMulti={false}
                            isLoading={this.props.ratingRange.isLoading}
                            placeholder={this.props.t(`Common.Select`)}
                        />
                    </FieldHorizontal>
                    <FieldHorizontal label={this.props.t(`IRating.Report.Search.Partners`)}>
                        <CustomSelect
                            value={this.props.partnersValue}
                            onChange={this.props.partnersOnChange}
                            options={this.props.domains.partners.map(x => { return { value: x.code, label: x.name } })}
                            isMulti={true}
                            isLoading={this.props.domains.isLoading}
                            isSearchable
                            placeholder={this.props.t(`Common.Select`)}
                            isClearable
                        />
                    </FieldHorizontal>
                </>
            );
        }
        else {
            return null;
        }
    }
}

ReportPermissionsFormComponent.propTypes = {
    publishAboveRatingValue: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.string
    ]),
    publishAboveRatingOnChange: PropTypes.func.isRequired,
    partnersValue: PropTypes.array.isRequired,
    partnersOnChange: PropTypes.func.isRequired
}

export default withTranslation("translation")(connect(
    state => state.appContext,
    dispatch => bindActionCreators(appContextActions, dispatch)
)(ReportPermissionsFormComponent));